import { CmsPersonalDetailsForm } from '../cms/cms-personal-details-form.interface';
import { PersonalDetailsFormValue } from './personal-details-form-value.type';

export interface PersonalDetailsFormConfig {
  cmsData: CmsPersonalDetailsForm;
  initialValue?: PersonalDetailsFormValue;
}
